import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, Config, ConfirmDialog, ErrorDialog } from 'omni-common-ui';
import { exporter } from 'domain/Exporter';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import * as Session from 'data/SessionPlans/accessors';
import * as GroupMembers from 'data/GroupMembers/accessors';
import { actions as CoveredInClassActions } from 'data/CoveredInClass';
import { actions as CoveredInClassTemplateActions } from 'data/CoveredInClass/Template';
import { actions as FeedbackActions } from 'data/Feedback';
import { CATEGORY_GRAMMAR_PRO, Modes } from './routes';
import Feedback from './Feedback';
import GrammarPro from './GrammarPro';

const EXPORTING_MESSAGE = 'Exporting reports, please wait';

export class SessionReport extends UnsavedChangesTrackingPageComponent {
  constructor() {
    super();
    this.state = {
      isSaving: false,
      isExportInProgress: false,
      isExportErrorOccurred: false,
    };
  }

  componentWillMount() {
    this._redirectTo(this.props);
    this._setUpData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._redirectTo(nextProps);
    this._setUpData(nextProps);
  }

  _setUpData(props) {
    const sessionPlanId = this._getSessionPlanId(props);
    const studentId = this._getStudentId(props);
    props.fetchCoveredInClassIfNeeded(sessionPlanId);
    props.fetchCoveredInClassTemplateIfNeeded(sessionPlanId, true);
    props.fetchFeedbackIfNeeded(sessionPlanId, studentId);
  }

  _redirectTo(props) {
    const {
      buildRoute,
      replace,
      params,
      mode,
    } = props;
    if (is.existy(mode) && mode === Modes.EXPORT) {
      this._beginExport(props);
      return replace(buildRoute({
        mode: '',
      }));
    }
    if (is.existy(params.sessionPlanId) &&
      is.existy(params.unitId) &&
      is.existy(params.studentId) &&
      is.existy(params.category)) {
      this.setState({
        isSaving: false,
      });
      return;
    }
    const sessionPlanId = this._getSessionPlanId(props);
    const unitId = params.unitId || props.unitId;
    const studentId = params.studentId || props.studentId;
    const category = params.category || CATEGORY_GRAMMAR_PRO;

    return replace(buildRoute({
      sessionPlanId,
      unitId,
      studentId,
      category,
    }));
  }

  _getSessionPlanId(props) {
    return props.params.sessionPlanId || props.sessionPlanId;
  }

  _getStudentId(props) {
    return props.params.studentId || props.studentId;
  }

  routerWillLeave(nextLocation) {
    if (nextLocation.pathname.endsWith(Modes.SAVE)) {
      this.setState({
        isSaving: true,
      });
      return false;
    }
    super.routerWillLeave(nextLocation);
  }

  _beginExport(props) {
    const sessionPlanId = this._getSessionPlanId(props);
    const studentId = this._getStudentId(props);
    const url = Config.get('apiBase').concat(`/sessions/${sessionPlanId}/students/${studentId}/feedback-printing`);
    this.setState({
      isExportInProgress: true,
    });
    exporter.get(url,
      'SessionReport.pdf',
      false,
      'application/pdf'
    ).then(() => {
      this.setState({
        isExportInProgress: false,
      });
    }).catch(() => {
      this._handleExportError();
    });
  }

  _handleExportError() {
    this.setState({
      isExportInProgress: false,
    });
    this._onBeginGeneralError();
  }

  _onBeginGeneralError() {
    this.setState({ isExportErrorOccurred: true });
  }

  _onEndExportWarningOrError() {
    this.setState({
      isExportErrorOccurred: false,
    });
  }

  _renderExportGeneralErrorDialog() {
    return <ErrorDialog isOpen={this.state.isExportErrorOccurred}
        onConfirmClick={() => {
          this._onEndExportWarningOrError();
        }} />;
  }

  _renderExportingDialog() {
    return <ConfirmDialog isOpen={this.state.isExportInProgress}
        isLoading
        isButtonless
        title={EXPORTING_MESSAGE} />;
  }

  render() {
    const { category, mode, buildRoute, index, groupId } = this.props;
    const sessionPlanId = this._getSessionPlanId(this.props);
    const studentId = this._getStudentId(this.props);
    return <div>
      { category === CATEGORY_GRAMMAR_PRO ?
        <GrammarPro sessionPlanId={sessionPlanId}
            groupId={groupId}
            buildRouteWithContext={buildRoute}
            mode={this.state.isSaving ? Modes.SAVE : mode}
            index={index} /> :
        <Feedback mode={mode}
            groupId={groupId}
            studentId={studentId}
            sessionPlanId={sessionPlanId} />}
      {this._renderExportGeneralErrorDialog()}
      {this._renderExportingDialog()}
    </div>;
  }
}

SessionReport.propTypes = {
  buildRoute: PropTypes.func,
  category: PropTypes.string,
  groupId: PropTypes.string,
  mode: PropTypes.string,
  sessionPlanId: PropTypes.string,
  unitId: PropTypes.string,
  studentId: PropTypes.string,
  index: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const { category, groupId, mode, index } = ownProps.params;
  const defaultSession = Session.getDefaultSession(state, groupId);
  const sessionPlanId = defaultSession && defaultSession.id;
  const unitId = Session.getFirstUnitOfSession(state, sessionPlanId);
  const member = GroupMembers.getDefaultMember(state, groupId);
  return {
    category,
    groupId,
    mode,
    index,
    sessionPlanId,
    unitId,
    studentId: member && member.studentGeneralInfo.id,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    {},
    bindActionCreators(CoveredInClassActions, dispatch),
    bindActionCreators(CoveredInClassTemplateActions, dispatch),
    bindActionCreators(FeedbackActions, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SessionReport));



// WEBPACK FOOTER //
// ./containers/Group/SessionReport/component.jsx